import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
export interface SettingsWrapperProps {
  children: ReactNode;
}
export const SettingsWrapper: React.FC<SettingsWrapperProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="bg-background-secondary flex h-full w-full flex-col gap-7 overflow-x-hidden rounded-md p-5">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};